import * as React from 'react';

interface Props {
    label: string;
    className: string;
}

export default class PropertyListItem extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { label, children, className } = this.props;

        const classNames: Array<string> = [className, 'ddbc-property-list__property'];

        return (
            <div className={classNames.join(' ')}>
                <div className="ddbc-property-list__property-label">{label}:</div>
                <div className="ddbc-property-list__property-content">{children}</div>
            </div>
        );
    }
}
